import React from "react";
import logo from "../Assets/logo-spotify.svg";
import { Link } from "react-router-dom";
// import { MenuList } from "@mui/material";

function NavBar({ openSideBar, setOpenSideBar, navLinks, supportPage }) {
  return (
    <>
      <nav role="navigation" className="navbar relative">
        <div
          className={`${
            supportPage ? "bg-green-900" : "bg-black"
          } flex justify-between items-center px-4 py-4 md:px-6 lg:px-14 xl:px-28 xl:py-5`}
        >
          <div>
            <img
              src={logo}
              alt="logo"
              className={`${
                openSideBar ? "hidden" : "block"
              } h-6 md:h-8 lg:h-10`}
            />
          </div>
          <div
            onClick={() => setOpenSideBar(!openSideBar)}
            className=" z-20 cursor-pointer text-white text-bold lg:hidden"
          >
            {openSideBar ? (
              <ion-icon size="large" name="close-outline"></ion-icon>
            ) : (
              <ion-icon size="large" name="menu-outline"></ion-icon>
            )}
          </div>

          <div
            onClick={() => setOpenSideBar(!openSideBar)}
            className={`w-[100%] absolute inset-y-0 left-0 z-10
      ${
        openSideBar
          ? "translate-x-0 transition duration-500 ease-in-out"
          : "-translate-x-full transition duration-500 ease-in-out "
      }`}
          >
            <ul className="bg-black pl-8 pt-8 -top-14 h-screen lg:hidden ">
              <li className="text-white font-bold text-2xl hover:text-green-500 transition duration-500">
                <Link to="/premium">{navLinks[0].link1}</Link>
              </li>
              <li className=" text-white font-bold text-2xl mt-6 hover:text-green-500 transition duration-500">
                <Link to="/support">{navLinks[1].link2}</Link>
              </li>
              <li className="text-white font-bold text-2xl mt-6 hover:text-green-500 transition duration-500">
                <Link to="/download">{navLinks[2].link3}</Link>
              </li>
              <li className="text-white font-extrabold text-2xl mt-6">
                <ion-icon name="remove-outline"></ion-icon>
              </li>
              <li className="text-white font-normal text-xl mt-6  hover:text-green-500 transition duration-500">
                <Link to="/signup">{navLinks[3].link4}</Link>
              </li>
              <li className="text-white font-normal text-xl mt-6 hover:text-green-500 transition duration-500">
                <Link to="/login">{navLinks[4].link5}</Link>
              </li>

              <img
                src={logo}
                alt="logo"
                className={`${
                  openSideBar ? "block" : "hidden"
                } h-6 mt-36 cursor-pointer`}
              />
            </ul>
          </div>

          <ul className="hidden lg:flex lg:float-right lg:gap-4 text-white lg:text-sm lg:font-semibold">
            <li className="hover:text-green-500 transition duration-500">
              <Link to="/premium">{navLinks[0].link1}</Link>
            </li>
            <li className="hover:text-green-500 transition duration-500">
              <Link to="/support">{navLinks[1].link2}</Link>
            </li>
            <li className="hover:text-green-500 transition duration-500">
              <Link to="/download">{navLinks[2].link3}</Link>
            </li>
            <li className="font-thin">|</li>
            <li className="text-slate-300 hover:text-green-500 transition duration-500">
              <Link to="/signup">{navLinks[3].link4}</Link>
            </li>
            <li className="text-slate-300 hover:text-green-500 transition duration-500">
              <Link to="/login">{navLinks[4].link5}</Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default NavBar;
